'use strict';

module.exports = {
    dataUrl: 'accommodation/results/fromTo',

    url() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    update(fromTo, templates) {
        this.clear().fetch(Odigeo._.extend(this.getResults(fromTo), {
            success: () => {
                this.successFetch(templates);
            },
            error: (error) => {
                this.errorFetch(error);
            },
        }));
    },

    successFetch(templates) {
        this.set('templates', templates);
        this.trigger('loadAccommodationResults');
    },

    errorFetch(error) {
        Odigeo.trigger(`${this.widget.id}:accommodationResults`, error);
    },

    getResults({from, to}) {
        return {
            dataType: 'json',
            contentType: 'application/json',
            type: 'GET',
            cache: false,
            data: {from, to},
        };
    },
};
